import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useListEmployees({
  statusFilter,
  textFilter,
  searchTypeId,
  departmentId,
  businessLocationId,
  menu,
  dateType,
  fromDate,
  toDate,
}) {
  const { rowsPerPage } = useApp();

  const { data, isLoading, isRefetching, isFetching, refetch } = useList(
    'getCompanyEmployees',
    {
      all: 1,
      module: 'employeedata',
      status: statusFilter,
      searchName: textFilter,
      searchType: searchTypeId,
      isDept: departmentId,
      isBusinessLoc: businessLocationId,
      rowsPerPage,
      menu: menu,
      dateType: fromDate || toDate ? dateType : undefined,
      fromDate,
      toDate,
    },
  );

  return {
    data: data?.data?.data?.data || [],
    count: data?.data?.data?.total_count,
    isLoading: isLoading || isRefetching || isFetching,
    refetch,
  };
}
